@if (show && params?.value) {
  <span class="badge {{ badgeClass }}">{{ label }}</span>
}
